import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useState } from "react";

const useEditDateOfLastContact = () => {
  const { lead } = useContext(LeadPageContext);
  const [dateOfLastContact, setDateOfLastContact] = useState<
    string | Date | Date[] | null
  >(null);
  const [
    editLeadDateOfLastContactModalOpen,
    setEditLeadDateOfLastContactModalOpen,
  ] = useState(false);

  return {
    dateOfLastContact: {
      editLeadDateOfLastContactModalOpen,
      setEditLeadDateOfLastContactModalOpen,
      setDateOfLastContact,
      state: dateOfLastContact,
      setState: setDateOfLastContact,
      initialValue: lead?.data?.lead?.date_of_last_contact,
      value: lead?.data?.lead?.date_of_last_contact,
    },
  };
};

export default useEditDateOfLastContact;
